/* ============================================================
   NGX Upsell v3 — assets/ngx-upsell.js
   NextGen Supplements · Add-on-Vorschläge (Cart-Drawer, PDP)

   - Eigenes Custom Element <ngx-upsell-card>. Fasst CartDrawer,
     CartItems, Kaching oder die vcd-Ladder NICHT an.
   - Add via /cart/add.js mit sections-Param, danach
     cart-drawer.renderContents() — identischer Flow wie der
     Theme-Add und wie assets/vcd-crosssell.js.
   - Abo-Adds übergeben selling_plan; ohne Plan → Einmalkauf.
   - Preise sind serverseitig vorformatiert (money-Filter) und stehen als
     Data-Attribute an der Karte bzw. an den <option>-Elementen. Hier wird
     nur getauscht, kein Währungsformat im JS, kein JSON-Parsing.
   - Kein Ablehnen-Button. Gemerkt wird nur, ob ein Slot gesehen wurde;
     das dient allein dem View-Tracking.
   - Tracking: window.dataLayer, Shopify.analytics.publish und
     DOM-CustomEvent 'ngx:upsell'.
     Events: ngx_upsell_view · ngx_upsell_accept

   v3 enthält zusätzlich eine additive Korrektur eines Theme-Bugs,
   siehe fixEmptyDrawer() weiter unten.
   ============================================================ */

(function () {
  if (window.customElements && customElements.get('ngx-upsell-card')) return;

  var store = {
    get: function (k) {
      try {
        return window.sessionStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set: function (k, v) {
      try {
        window.sessionStorage.setItem(k, v);
      } catch (e) {
        /* privater Modus oder blockiert: ohne Merker weiterlaufen */
      }
    },
  };

  /* ----------------------------------------------------------
     THEME-BUG: CartDrawer.renderContents() entfernt die Klasse
     is-empty nur von .drawer__inner, nicht vom <cart-drawer>
     selbst. Wird der erste Artikel in einen leeren Warenkorb
     gelegt, bleibt der Drawer deshalb im Leer-Layout:
       cart-drawer.is-empty .drawer__header { display: none }
       cart-drawer.is-empty .drawer__inner  { display: grid;
         grid-template-rows: 1fr; align-items: center; padding: 0 }
     Ergebnis: keine Kopfzeile, Inhalt mittig gestaucht, kein
     Innenabstand. cart.js korrigiert die Klasse nur bei
     Mengenänderungen, nicht beim Hinzufügen.

     Wir korrigieren additiv: einmal direkt vor unserem eigenen
     Render und einmal global über das cartUpdate-Event, damit
     auch der Theme-eigene Add-to-Cart auf den Produktseiten
     sauber läuft. Die Datei cart-drawer.js bleibt unangetastet.
     ---------------------------------------------------------- */
  function fixEmptyDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        // Mengenänderungen behandelt cart.js selbst korrekt (inkl. Leerung).
        if (evt && evt.source === 'cart-items') return;
        fixEmptyDrawer();
      });
    }
  } catch (e) {}

  function track(name, payload) {
    var data = Object.assign({ event: name }, payload || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('ngx:upsell', { detail: data }));
    } catch (e) {}
  }

  var viewObserver = null;
  function getViewObserver() {
    if (viewObserver || !('IntersectionObserver' in window)) return viewObserver;
    viewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          viewObserver.unobserve(entry.target);
          if (typeof entry.target._onViewed === 'function') entry.target._onViewed();
        });
      },
      { threshold: 0.5 }
    );
    return viewObserver;
  }

  class NgxUpsellCard extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this._onAdd = this._onAdd.bind(this);
      this._onVariant = this._onVariant.bind(this);
      this._onMode = this._onMode.bind(this);
    }

    connectedCallback() {
      this.slotName = this.dataset.ngxSlot || 'X';
      this.handle = this.dataset.ngxProduct || '';
      this.mode = this.dataset.ngxMode || 'otp';
      this.addBtn = this.querySelector('[data-ngx-add]');
      this.variantSelect = this.querySelector('[data-ngx-variant-select]');
      this.priceEl = this.querySelector('[data-ngx-price-out]');
      this.modeInputs = Array.prototype.slice.call(this.querySelectorAll('[data-ngx-mode-input]'));

      if (this.addBtn) this.addBtn.addEventListener('click', this._onAdd);
      if (this.variantSelect) this.variantSelect.addEventListener('change', this._onVariant);
      this.modeInputs.forEach(function (i) {
        i.addEventListener('change', this._onMode);
      }, this);

      this._sync();

      var self = this;
      this._onViewed = function () {
        store.set('ngx_seen_' + self.slotName, '1');
        track('ngx_upsell_view', self._payload());
      };
      var obs = getViewObserver();
      if (obs) obs.observe(this);
      else this._onViewed();
    }

    disconnectedCallback() {
      if (this.addBtn) this.addBtn.removeEventListener('click', this._onAdd);
      if (this.variantSelect) this.variantSelect.removeEventListener('change', this._onVariant);
      this.modeInputs.forEach(function (i) {
        i.removeEventListener('change', this._onMode);
      }, this);
      if (viewObserver) viewObserver.unobserve(this);
    }

    // Aktuelle Variante: aus der gewählten <option>, sonst aus der Karte selbst.
    _current() {
      if (this.variantSelect && this.variantSelect.selectedOptions.length) {
        var o = this.variantSelect.selectedOptions[0];
        return {
          id: Number(o.value),
          price: o.dataset.price || '',
          plan: o.dataset.plan || '',
          planPrice: o.dataset.planPrice || '',
        };
      }
      return {
        id: Number(this.dataset.ngxVariant),
        price: this.dataset.ngxPrice || '',
        plan: this.dataset.ngxPlan || '',
        planPrice: this.dataset.ngxPlanPrice || '',
      };
    }

    _sync() {
      var v = this._current();
      if (!v || !v.id) return;
      var hasPlan = !!v.plan;
      if (this.mode === 'abo' && !hasPlan) this.mode = 'otp';
      this.dataset.ngxMode = this.mode;

      if (this.addBtn) {
        this.addBtn.dataset.variantId = String(v.id);
        this.addBtn.dataset.sellingPlan = this.mode === 'abo' ? String(v.plan) : '';
      }
      if (this.priceEl) {
        this.priceEl.innerHTML =
          this.mode === 'abo'
            ? '<s>' + v.price + '</s> <b>' + v.planPrice + '</b> <i>im Abo</i>'
            : '<b>' + v.price + '</b>';
      }
      this.modeInputs.forEach(function (i) {
        if (i.value === 'abo') i.disabled = !hasPlan;
        i.checked = i.value === this.mode;
      }, this);
    }

    _payload(extra) {
      var v = this._current() || {};
      return Object.assign(
        {
          slot: this.slotName,
          product_handle: this.handle,
          variant_id: v.id || null,
          mode: this.mode,
          cart_type: this.dataset.ngxCartType || '',
          cart_value: Number(this.dataset.ngxCartValue || 0),
        },
        extra || {}
      );
    }

    _onVariant() {
      this._sync();
    }

    _onMode(evt) {
      this.mode = evt.target.value === 'abo' ? 'abo' : 'otp';
      this._sync();
    }

    _onAdd(evt) {
      evt.preventDefault();
      if (this.loading) return;
      var variantId = Number(this.addBtn.dataset.variantId);
      if (!variantId) return;
      var plan = this.addBtn.dataset.sellingPlan;

      this._setLoading(true);
      var item = { id: variantId, quantity: 1 };
      if (plan) item.selling_plan = Number(plan);

      var body = {
        items: [item],
        sections: this._sectionsToRender(),
        sections_url: window.location.pathname,
      };
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var self = this;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (parsed) {
          if (parsed && parsed.status) {
            // Fehlerobjekt von /cart/add.js, z.B. 422 nicht verfügbar
            self._setLoading(false);
            self._showError(parsed.description || parsed.message || 'Konnte nicht hinzugefügt werden.');
            return;
          }
          track('ngx_upsell_accept', self._payload({ selling_plan: plan ? Number(plan) : null }));

          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
            // Der Warenkorb ist jetzt sicher nicht mehr leer. Ohne diese Zeile
            // bliebe der Drawer im Leer-Layout (siehe fixEmptyDrawer oben).
            fixEmptyDrawer();
            // renderContents ersetzt den Drawer-Inhalt und öffnet ihn (Theme-Flow)
            drawer.renderContents(parsed);
            self._setLoading(false);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          self._setLoading(false);
          self._showError('Verbindung fehlgeschlagen. Bitte noch einmal versuchen.');
        });
    }

    _sectionsToRender() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',');
      }
      return 'cart-drawer,cart-icon-bubble';
    }

    _showError(msg) {
      var el = this.querySelector('[data-ngx-error]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'ngx-u__error';
        el.setAttribute('data-ngx-error', '');
        el.setAttribute('role', 'alert');
        this.appendChild(el);
      }
      el.textContent = msg;
    }

    _setLoading(state) {
      this.loading = state;
      this.classList.toggle('ngx-u--loading', state);
      if (!this.addBtn) return;
      this.addBtn.toggleAttribute('disabled', state);
      this.addBtn.setAttribute('aria-busy', state ? 'true' : 'false');
    }
  }

  customElements.define('ngx-upsell-card', NgxUpsellCard);
})();
